"use client";

import { useRef, useState, useCallback, useEffect } from "react";

import { ModelsAwardsCarouselItem } from "@/types";
import { awardsCarouselContentVariant } from "./awards-carousel.variants";

export type UseAwardsCarouselItemsProps = {
  list: ModelsAwardsCarouselItem[];
};

export const useAwardsCarouselItems = (props: UseAwardsCarouselItemsProps) => {
  const { list } = props;

  const [value, setValue] = useState("item-0");
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startAutoplay = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    const total = list.length;
    intervalRef.current = setInterval(() => {
      setValue((v) => {
        const i = Number(v.replace("item-", ""));
        return `item-${(i + 1) % total}`;
      });
    }, 8000);
  }, [list.length]);

  const handleValueChange = (newValue: string) => {
    setValue(newValue);
    startAutoplay();
  };

  useEffect(() => {
    startAutoplay();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [startAutoplay, intervalRef]);

  const styles = awardsCarouselContentVariant();

  return {
    intervalRef,
    value,
    onValueChange: handleValueChange,
    onStartAutoplay: startAutoplay,
    list,
    styles,
  };
};
